import { useAuth } from '../lib/auth'
import { Brand, Centered } from './Login'
import { MFASection } from './Konto'

/**
 * Pflichtschritt nach der ersten Anmeldung: Ohne eingerichtete Zwei-Faktor-
 * Anmeldung gibt der Server keine Fachdaten heraus (docs/sicherheit.md). Diese
 * Seite steht deshalb vor der Anwendung, bis die Einrichtung abgeschlossen ist.
 */
export function MfaEinrichtungPage() {
  const { me, refresh, logout } = useAuth()
  if (!me) return null

  return (
    <Centered>
      <Brand />
      <div className="stack" style={{ gap: 16 }}>
        <div>
          <h1 className="page-title" style={{ marginBottom: 4 }}>
            Zwei-Faktor-Anmeldung einrichten
          </h1>
          <p className="muted" style={{ margin: 0 }}>
            Angemeldet als {me.email}. Die Anwendung wird erst nach der Einrichtung freigegeben.
          </p>
        </div>
        <MFASection enabled={false} onChanged={refresh} />
        <div>
          <button type="button" className="btn" onClick={logout}>
            Abmelden
          </button>
        </div>
      </div>
    </Centered>
  )
}
